<template>
  <div class="website-list-item">
    <div class="domain one-liner">{{ domain }}</div>
    <icon-cross width="24"
                height="24"
                color="#b9b9b9"
                class="btn-close"
                @click="$emit('deleteSetting', url.id)" />
  </div>
</template>

<script>
  import { getDomain } from '@/services/utils.js'

  export default {
    props: {
      url: {
        type: Object,
        required: true
      }
    },

    computed: {
      domain() {
        return getDomain(this.url.top_level_domain)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .website-list-item {
    height: 50px;
    padding: 0 3px 0 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #f2f2f2;

    .btn-close {
      cursor: pointer;
    }
  }
</style>
